import { render, staticRenderFns } from "./reflection_notes_modify.vue?vue&type=template&id=1c6cab16&"
import script from "./reflection_notes_modify.vue?vue&type=script&lang=js&"
export * from "./reflection_notes_modify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports